import React from "react";

export default function MySQL_SUM() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_SUM</h1>
      <p>This is the MySQL_SUM component generated from the SQL JSON.</p>
    </div>
  );
}
